import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { REFUND_STATUS_OPTIONS, SERVICE_STATUS_OPTIONS } from '../../../components/atoms/const';

function useCustomerSupport() {
  // const [searchParams] = useSearchParams();
  // console.log(searchParams.get('type'));

  const navigation = useNavigate();
  // Navigate to addServiceRequest
  const onNavigateToAddService = () => navigation('/customer-support/service/add');
  // Navigate to addRefundRequest
  const onNavigateToAddRefund = () => navigation('/customer-support/refund/add');

  const { currentScreen } = useParams();
  const [step, setStep] = React.useState<number>(0);
  const [statusService, setStatusService] = React.useState<{ value: number | null, label: string }>(SERVICE_STATUS_OPTIONS[0]);
  const [statusRefund, setStatusRefund] = React.useState<{ value: 'PAID' | 'UNPAID' | null, label: string }>(REFUND_STATUS_OPTIONS[0]);
  const [pageService, setPageService] = React.useState<number>(1);
  const [pageRefund, setPageRefund] = React.useState<number>(1);

  React.useEffect(() => {
    if (currentScreen === 'refund') setStep(1);
    else setStep(0);
  }, [currentScreen]);

  return {
    step: {
      current: step,
      setCurrent: setStep,
    },
    service: {
      current: statusService,
      setCurrent: setStatusService,
      options: SERVICE_STATUS_OPTIONS,
      page: pageService,
      setPage: setPageService,
    },
    refund: {
      current: statusRefund,
      setCurrent: setStatusRefund,
      options: REFUND_STATUS_OPTIONS,
      page: pageRefund,
      setPage: setPageRefund,
    },
    navigate: {
      service: onNavigateToAddService,
      refund: onNavigateToAddRefund,
    },
  };
}

export default useCustomerSupport;
